import React from 'react';

/*
    - ihoDesignSystem
*/
import { Alert, Container, Grid } from '@iho-design-system/Loader';

/*
    - component
*/
import List from '../components/favorite/List';
import Toolbar from '../components/favorite/Toolbar';

/*
    - api
*/
import getAPI from '../api/get';

const Favorite = () => {

    /*
        - defaultData
    */
    const [favoritesData, setFavoritesData] = React.useState({
        favorites: ''
    });
    const [reloadFavorite, setReloadFavorite] = React.useState('');
    const [hotelNameSearchKey, setHotelNameSearchKey] = React.useState('');

    /*
        - alert
    */
    const [alert, setAlert] = React.useState('');
    const [alertColor, setAlertColor] = React.useState('success');
    const [alertStatus, setAlertStatus] = React.useState('d-none');
    const alertProps = (config) => {
        setAlert(config[1])
        setAlertColor(config[0]);
        setAlertStatus('d-flex');
        setTimeout(() => {
            setAlertStatus('d-none');
        }, 2500);
    }

    /*
        - fetchData
    */
    React.useEffect(() => {
        const fetchData = async () => {
            let favoritsParameters = {
                ctrl: 'UserProfile',
                method: 'GetFavorites',
                query: ''
            }
            setFavoritesData({
                favorites: await getAPI(favoritsParameters)
            });
        }
        fetchData();
    }, [reloadFavorite]);

    /*
        - reloadFavoriteProps
    */
    const reloadFavoriteProps = (reloadFavoriteProps) => {
        setReloadFavorite(reloadFavoriteProps);
    }

    /*
        - searchProps
    */
    const hotelNameSaerchPrps = (hotelNameSaerchPrps) => {
        setHotelNameSearchKey(hotelNameSaerchPrps);
    }

    /*
        - componentData
    */
    let listData = [];
    listData.favorites = favoritesData.favorites;
    listData.hotelNameSearchKey = hotelNameSearchKey;

    return (
        <React.Fragment>
            <Container
                size='lg'>
                <Grid>
                    <Grid.Wrapper>
                        <Grid.Item
                            className={`pr-0 pl-0`}
                            size='col-12'>
                            <Toolbar
                                hotelNameSaerchPrps={hotelNameSaerchPrps} />
                        </Grid.Item>
                        <Grid.Item
                            className={`pr-0 pl-0`}
                            size='col-12'>
                            <List
                                props={listData}
                                alertProps={alertProps}
                                reloadFavoriteProps={reloadFavoriteProps} />
                        </Grid.Item>
                    </Grid.Wrapper>
                </Grid>
            </Container>
            <Alert
                className={`alert ${alertStatus}`}
                color={alertColor}
                ms={{
                    bottom: '75px !important'
                }}>
                {alert}
            </Alert>
        </React.Fragment>
    );

}

export default Favorite;